// extracted by mini-css-extract-plugin
module.exports = {"scroll":"scroll_scroll__4seUk","scrollXAxis":"scroll_scrollXAxis__2-hKl","scrollYAxis":"scroll_scrollYAxis__39j2-"};